import React, { useState, useEffect } from 'react';
import { MapPin, Phone } from 'lucide-react';
import api from '../../../services/api';

const LocationsPreview = ({ isAdminPreview = true }) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await api.get('/business/locations/');
      setLocations(res.data || []);
    } catch (err) {
      console.error('Error fetching locations:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!locations.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#0f172a',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No locations added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#0f172a', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        Our Locations
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1rem'
      }}>
        {locations.slice(0, 4).map((location, index) => (
          <div
            key={location.id || index}
            style={{
              padding: '1rem',
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderRadius: '0.75rem',
              border: '1px solid rgba(255,255,255,0.1)'
            }}
          >
            <h3 style={{ color: '#fff', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>
              {location.name}
            </h3>
            {location.address && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.25rem' }}>
                <MapPin size={12} style={{ color: '#6366f1', flexShrink: 0, marginTop: '2px' }} />
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.7rem', lineHeight: '1.4' }}>
                  {location.address}
                </span>
              </div>
            )}
            {location.phone && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Phone size={12} style={{ color: '#10b981', flexShrink: 0 }} />
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.7rem' }}>
                  {location.phone}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationsPreview;
